import HealthHiringInsured from '@/modules/health/hiring/models/APP/HealthHiringInsured'
import HiringAnswers from '@/modules/common/hiring/models/APP/HiringAnswers'

export default class HealthHiringAnswers extends HiringAnswers<HealthHiringInsured> {
  protected _holder = new HealthHiringInsured()
  protected _betterAssurance!: boolean | null
  protected _coverageCode?: string | null

  constructor(data: Partial<HealthHiringAnswers> = {}) {
    super(data)

    this.insureds = data.insureds
    this.holder = data.holder
    this.betterAssurance = data.betterAssurance
    this.coverageCode = data.coverageCode
  }

  get insureds(): HealthHiringInsured[] {
    return this._insureds
  }

  set insureds(value: HealthHiringInsured[] | undefined) {
    this._insureds = value?.map((i) => new HealthHiringInsured(i)) ?? []
  }

  get holder(): HealthHiringInsured {
    return this._holder
  }

  set holder(value: HealthHiringInsured | undefined) {
    this._holder.updateAttributes(value ?? {})
  }

  get currentInsured(): HealthHiringInsured | null {
    return this._currentInsured ?? null
  }

  set currentInsured(value: HealthHiringInsured | null | undefined) {
    this._currentInsured = value ? new HealthHiringInsured(value) : null
  }

  get betterAssurance(): boolean | null {
    return this._betterAssurance
  }

  set betterAssurance(value: boolean | null | undefined) {
    if (value === false) {
      this.insureds.forEach((i) => (i.additionalCoverages = []))
    }

    this._betterAssurance = value ?? null
  }

  get coverageCode(): string | null {
    return this._coverageCode ?? null
  }

  set coverageCode(value: string | null | undefined) {
    this._coverageCode = value ?? null
  }

  updateAttributes(newAttributes: Partial<HealthHiringAnswers>) {
    Object.assign(this, newAttributes)
  }

  hasBetterAssurance(): boolean {
    return !!this.insureds.find((insured) => insured.additionalCoverages?.length)
  }

  hasAnotherCompany(): boolean {
    return !!this.insureds.find((insured) => insured.anotherCompany)
  }
}
